import React, { useState } from 'react';
import {
  TextField,
  Button,
  Box,
  Typography,
  Paper,
  Skeleton
} from '@mui/material';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const showSuccessToast = (message) => toast.success(message);
const showErrorToast = (message) => toast.error(message);

const AddProjectForm = ({ onAddSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [siteUrl, setSiteUrl] = useState('');
  const [consumerKey, setConsumerKey] = useState('');
  const [consumerSecret, setConsumerSecret] = useState('');

  const handleSubmit = async () => {
    if (!siteUrl || !consumerKey || !consumerSecret) {
      showErrorToast("لطفا تمام فیلدها رو پر کنید ⚠️ ");
      return;
    }

    setLoading(true);

    try {
      // تست API WooCommerce
      const testRes = await fetch('/db/test-wc-api.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ siteUrl, consumerKey, consumerSecret }),
      });

      const testResult = await testRes.json();

      if (testResult.status === 'success') {
        showSuccessToast(" تمام تست‌ها با موفقیت انجام شد ✅ ");

        // ثبت پروژه در دیتابیس
        const addRes = await fetch('/db/add-project.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ siteUrl, consumerKey, consumerSecret }),
        });

        const addResult = await addRes.json();

        if (addResult.status === 'success') {
          showSuccessToast(" پروژه ذخیره شد 🎉 ");
          onAddSuccess?.();
        } else {
          showErrorToast("❌ " + addResult.message);
        }

      } else if (testResult.status === 'partial_error') {
        // نمایش نتیجه تست‌ها بصورت جداگانه
        testResult.results.forEach((result) => {
          if (result.status === 'failed') {
            const errorMessage = result.error ? `${result.error}` : '';
            showErrorToast(`🚫 ${result.endpoint}: دسترسی ناموفق - ${errorMessage}`);
          } else {
            showSuccessToast(`✅ ${result.endpoint}: دسترسی موفق`);
          }
        });
      } else {
        showErrorToast(" آدرس سایت شما درست نیست یا ووکامرس در سایت شما نصب نمی باشد ❌ ");
      }
    } catch (err) {
      console.error(err);
      showErrorToast("🚫 خطایی در برقراری ارتباط رخ داد");
    }

    setLoading(false);
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        افزودن پروژه جدید
      </Typography>

      {loading ? (
        <>
          <Skeleton variant="rectangular" height={60} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={60} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={60} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" height={48} />
        </>
      ) : (
        <>
          <TextField
            label="آدرس سایت ووکامرس"
            placeholder='با https وارد کنید . مثال : https://emad.team'
            name="siteUrl"
            fullWidth
            margin="normal"
            value={siteUrl}
            onChange={(e) => setSiteUrl(e.target.value)}
          />

          <TextField
            label="Consumer Key"
            placeholder='با  _CK  شروع می شود'
            name="consumerKey"
            type="text"
            fullWidth
            margin="normal"
            value={consumerKey}
            onChange={(e) => setConsumerKey(e.target.value)}
          />

          <TextField
            label="Consumer Secret"
            placeholder='با  _CS  شروع می شود'
            name="consumerSecret"
            type="text"
            fullWidth
            margin="normal"
            value={consumerSecret}
            onChange={(e) => setConsumerSecret(e.target.value)}
          />

          <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            onClick={handleSubmit}
          >
            تست و ثبت پروژه
          </Button>
        </>
      )}
    </Paper>
  );
};

export default AddProjectForm;